<template>
    <div class="w-full">
        <multiselect
            v-model="props.selectedUsers"
            id="ajax-1"
            label="name"
            track-by="id"
            placeholder="Type to find users"
            open-direction="bottom"
            :options="state.users"
            :multiple="true"
            :searchable="true"
            :loading="state.isLoading"
            :internal-search="false"
            :clear-on-select="true"
            :close-on-select="true"
            :options-limit="300"
            :limit="10"
            :limit-text="limitText"
            :max-height="600"
            :show-no-results="false"
            :hide-selected="true"
            :show-labels="false"
            :show-no-options="false"
            @close="onClose"
            @select="selectUser"
            @remove="removeUser"
            @search-change="searchUsers"
        >
            <template #tag="{ option, remove }">
                <div class="flex items-center gap-2 bg-gray-100 rounded p-2">
                    <img
                        :src="option.avatar"
                        :alt="option.name"
                        class="w-8 h-8 aspect-square rounded-full"
                        onerror="this.onerror=null;this.src='/default-images/avatar.png';this.style.backgroundImage = 'none';"
                    />
                    <span class="text-[16px]">{{ option.name }}</span>
                    <button
                        type="button"
                        @click="remove(option)"
                        class="
                            bg-transparent
                            text-gray-500
                            flex
                            items-center
                            hover:text-gray-700 hover:bg-gray-300
                            p-1
                            rounded-lg
                        "
                    >
                        <ion-icon name="close-outline"></ion-icon>
                    </button>
                </div>
            </template>

            <template #option="props">
                <div class="flex items-center gap-2">
                    <img
                        :src="props.option.avatar"
                        :alt="props.option.name"
                        class="w-8 h-8 aspect-square rounded-full"
                        onerror="this.onerror=null;this.src='/default-images/avatar.png';this.style.backgroundImage = 'none';"
                    />
                    <span>{{ props.option.name }}</span>
                </div>
            </template>
        </multiselect>
    </div>
</template>

<script setup>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { reactive, onMounted, defineProps } from "vue";
import { debounce } from "./utils";

const emit = defineEmits(["select"]);

const props = defineProps({
    currentUsers: {
        type: Array,
        required: true,
    },
    selectedUsers: {
        type: Array,
        required: true,
    },
});

const state = reactive({
    isLoading: false,
    users: [],
});

function limitText(count) {
    return `and ${count} other users`;
}

function onClose() {
    state.users = [];
}

function selectUser(user) {
    emit("select", user);
}

function removeUser(user) {
    emit("remove", user);
}

function clearAll() {
    emit("clear");
}

function validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function searchUsers(query) {
    if (query.length < 3) {
        return;
    }

    state.isLoading = true;
    axios
        .get("/utils/autocomplete-user", {
            params: {
                query: query,
                excludes: props.currentUsers
                    .filter((u) => !!u.user)
                    .map((u) => u.user_id)
                    .join(","),
            },
        })
        .then((response) => {
            console.log({ ra: response.data });
            state.users = response.data?.map((user) => {
                return {
                    name: user.name,
                    id: user.id,
                    avatar: user.avatar,
                };
            });
        })
        .finally(() => {
            state.isLoading = false;
        });
}
</script>

<style>
.multiselect__option--highlight {
    background: #048abf;
}
.multiselect__tags-wrap {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
}
.multiselect__input,
.multiselect__single {
    font-size: 14px;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>
